import {connect} from 'react-redux'
import {closeModal} from 'actions/subscriptionExpired'
import addIdentify from 'mixpanel/identify'
import Layout from 'components/Layout'

class App extends React.Component {
  componentDidMount () {
    const {loggedIn, user} = this.props.data.moka

    if (loggedIn) {
      addIdentify(user.id)
    }
  }

  render () {
    let { data, history, dispatch, location, routes, children } = this.props

    return (
      <div>
        <Layout
          data={data}
          history={history}
          dispatch={dispatch}
          location={location}
          routes={routes}
          children={children}
        />
      </div>
    )
  }
  _getClassByPath () {
    let {location} = this.props
    let classbyPath = location.pathname.split('/')
    if (location.pathname.startsWith('/feedback')) {
      return 'feedback'
    }
    if (classbyPath[1] === 'reset-password') {
      return 'reset-password'
    }
    return classbyPath[classbyPath.length - 1]
  }

  _hideExpiredModal = () => {
    this.props.dispatch(closeModal())
  }
}

App.propTypes = {
  data: React.PropTypes.object,
  history: React.PropTypes.object,
  location: React.PropTypes.object,
  children: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  outlets: React.PropTypes.array
}

function select (state) {
  return {
    data: state
  }
}

export default connect(select)(App)



// WEBPACK FOOTER //
// ./app/pages/App.js